// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={88}
    height={76}
    viewBox="0 0 88 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.12078 65.1358H82.8808C84.0265 65.1358 85.1253 64.6842 85.9355 63.8804C86.7457 63.0765 87.2008 61.9862 87.2008 60.8494V13.6992H0.800781V60.8494C0.800781 61.9862 1.2559 63.0765 2.06605 63.8804C2.87621 64.6842 3.97505 65.1358 5.12078 65.1358Z"
      fill="#FCFBF7"
    />
    <mask
      id="mask0_1399_522"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={13}
      width={88}
      height={53}
    >
      <path
        d="M5.12078 65.1358H82.8808C84.0265 65.1358 85.1253 64.6842 85.9355 63.8804C86.7457 63.0765 87.2008 61.9862 87.2008 60.8494V13.6992H0.800781V60.8494C0.800781 61.9862 1.2559 63.0765 2.06605 63.8804C2.87621 64.6842 3.97505 65.1358 5.12078 65.1358Z"
        fill="#FCFBF7"
      />
    </mask>
    <g mask="url(#mask0_1399_522)">
      <path
        d="M13.4331 32.9658C11.2126 40.9178 8.76096 50.0803 7.62459 54.0289C7.39305 54.8334 8.23588 55.9999 9.07307 55.9999H81V42.5755C81 40.8909 80.5744 39.2335 79.7627 37.7573L74.3592 27.93C73.0332 25.5184 69.7245 25.1352 67.8823 27.1798L64.6301 30.7894C63.3833 32.1733 61.3462 32.5134 59.7174 31.6095L56.8505 30.0185C54.9184 28.9462 52.4828 29.6438 51.4113 31.5764L46.5466 40.3504C45.3301 42.5445 42.4174 43.0901 40.4892 41.485L38.1013 39.4973C36.4144 38.093 33.911 38.3105 32.4914 39.9845L30.4247 42.4217C28.425 44.78 24.6201 44.0746 23.5985 41.1563L20.6667 32.7808C19.4024 29.169 14.4623 29.2802 13.4331 32.9658Z"
        fill="#FFD5E1"
      />
      <path
        d="M63.4008 70.7337L72.312 79.5756L77.7816 74.1485L68.8704 65.3067L75.0384 60.9512L51 53L59.0112 76.8537L63.4008 70.7337Z"
        fill="#E0DDD5"
      />
    </g>
    <path
      d="M8 54.9998C8.27788 54.6496 11.2379 42.342 13.9285 32.0341C14.8958 28.3285 19.7721 28.1968 21.0345 31.8124L23.9417 40.1387C24.9621 43.0613 28.7731 43.7668 30.7722 41.4033L32.8088 38.9954C34.2288 37.3165 36.7377 37.0986 38.4258 38.5075L40.781 40.473C42.71 42.0829 45.6283 41.5365 46.8443 39.3378L51.6842 30.5861C52.7553 28.6494 55.1954 27.9505 57.1294 29.0265L59.9624 30.6027C61.5932 31.5101 63.6348 31.1691 64.8823 29.781L67.994 26.3184C69.8671 24.2342 73.2473 24.6721 74.5274 27.1649L81 39.7691"
      stroke="#F95396"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <path
      d="M5.12078 65.1358H82.8808C84.0265 65.1358 85.1253 64.6842 85.9355 63.8804C86.7457 63.0765 87.2008 61.9862 87.2008 60.8494V13.6992H0.800781V60.8494C0.800781 61.9862 1.2559 63.0765 2.06605 63.8804C2.87621 64.6842 3.97505 65.1358 5.12078 65.1358V65.1358Z"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M5.12078 0.839844H82.8808C84.0265 0.839844 85.1253 1.29144 85.9355 2.0953C86.7457 2.89915 87.2008 3.98941 87.2008 5.12622V13.699H0.800781V5.12622C0.800781 3.98941 1.2559 2.89915 2.06605 2.0953C2.87621 1.29144 3.97505 0.839844 5.12078 0.839844Z"
      fill="#FF73A9"
    />
    <path
      d="M5.12078 0.839844H82.8808C84.0265 0.839844 85.1253 1.29144 85.9355 2.0953C86.7457 2.89915 87.2008 3.98941 87.2008 5.12623V13.699H0.800781V5.12623C0.800781 3.98941 1.2559 2.89915 2.06605 2.0953C2.87621 1.29144 3.97505 0.839844 5.12078 0.839844Z"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M74.2401 9.41236C75.433 9.41236 76.4001 8.45282 76.4001 7.26917C76.4001 6.08552 75.433 5.12598 74.2401 5.12598C73.0471 5.12598 72.0801 6.08552 72.0801 7.26917C72.0801 8.45282 73.0471 9.41236 74.2401 9.41236Z"
      fill="#29292F"
    />
    <path
      d="M80.7205 9.41236C81.9135 9.41236 82.8805 8.45282 82.8805 7.26917C82.8805 6.08552 81.9135 5.12598 80.7205 5.12598C79.5276 5.12598 78.5605 6.08552 78.5605 7.26917C78.5605 8.45282 79.5276 9.41236 80.7205 9.41236Z"
      fill="#29292F"
    />
    <path
      d="M67.8871 66.3978L76.7983 75.2396L82.2679 69.8126L73.3567 60.9707L79.5247 56.6153L55.4863 48.6641L63.4975 72.5178L67.8871 66.3978Z"
      fill="#FF73A9"
      stroke="#29292F"
      strokeMiterlimit={10}
    />
    <circle
      cx={54}
      cy={28}
      r={3}
      fill="#29292F"
    />
    <circle
      cx={35}
      cy={38}
      r={3}
      fill="#29292F"
    />
    <circle
      cx={17}
      cy={29}
      r={3}
      fill="#29292F"
    />
    <circle
      cx={71}
      cy={25}
      r={3}
      fill="#29292F"
    />
  </svg>
);
const SvgTourCapture = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgTourCapture;
